import { KeyValue } from '@/main/models/common';
import {
  ReportTemplateTypeTypes,
  ReportTemplateTypeActionTypes
} from './reportTemplateTypeTypes';

export function getReportTemplateType(
  keyReducer: string = 'default'
): ReportTemplateTypeActionTypes {
  return {
    type: ReportTemplateTypeTypes.GET_REPORT_TEMPLATE_TYPE,
    payload: { keyReducer }
  };
}

export function saveReportTemplateType(
  data: KeyValue[] | null,
  isError: boolean,
  errorMessages: string[] | null,
  keyReducer: string = 'default'
): ReportTemplateTypeActionTypes {
  return {
    type: ReportTemplateTypeTypes.SAVE_REPORT_TEMPLATE_TYPE,
    payload: { data, isError, errorMessages, keyReducer }
  };
}

export function resetReducerReportTemplateType(): ReportTemplateTypeActionTypes {
  return {
    type: ReportTemplateTypeTypes.RESET_REDUCER_REPORT_TEMPLATE_TYPE
  };
}

